import React from 'react';
import { Link } from 'react-router-dom';
import { CustomerCard as CustomerCardType } from '../salesRepCustomersTypes';
import { TierBadge } from '../../shared';
import styles from './CustomerCard.module.css';

interface CustomerCardProps {
  customer: CustomerCardType;
}

export const CustomerCard: React.FC<CustomerCardProps> = ({ customer }) => {
  return (
    <div className={styles.card}>
      <div className={styles.headerRow}>
        <h3 className={styles.name}>
          {customer.name}
          {customer.attentionDot && <span className={styles.attention} />}
        </h3>
        <p className={styles.city}>📍 {customer.city}</p>
      </div>
      <div className={styles.tierRow}>
        <TierBadge tier={customer.tier} />
        <span className={styles.segment}>{customer.segment}</span>
      </div>

      <div className={styles.statsGrid}>
        <div>
          <p className={styles.statLabel}>Revenue</p>
          <p className={styles.statValue}>{customer.revenue}</p>
        </div>
        <div>
          <p className={styles.statLabel}>Last Order</p>
          <p className={styles.statValue}>{customer.lastOrder}</p>
        </div>
        <div>
          <p className={styles.statLabel}>Margin</p>
          <p className={`${styles.statValue} ${styles[`margin_${customer.marginColor}`]}`}>
            {customer.margin}
          </p>
        </div>
        <div>
          <p className={styles.statLabel}>Profit</p>
          <p className={styles.statValue}>{customer.profit}</p>
        </div>
      </div>

      <div className={styles.actions}>
        {customer.phone ? (
          <a href={`tel:${customer.phone}`} className={styles.callBtn}>📞 Call</a>
        ) : (
          <button className={styles.callBtn} disabled title="No phone on file">📞 Call</button>
        )}
        <Link to={`/customer-details?id=${customer.id}`} className={styles.orderBtn}>+ Order</Link>
      </div>
    </div>
  );
};
